import { render, staticRenderFns } from "./ProofShare.vue?vue&type=template&id=15018f67&scoped=true"
import script from "./ProofShare.vue?vue&type=script&lang=js"
export * from "./ProofShare.vue?vue&type=script&lang=js"
import style0 from "./ProofShare.vue?vue&type=style&index=0&id=15018f67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15018f67",
  null
  
)

export default component.exports